import { ArrowDownward } from '@mui/icons-material';
import type { PlayerResponse } from '@on3/api';
import {
  type ColumnOption,
  getColumnHeaderList,
  SortFilter,
} from '@public/components/Db/Filters/SortFilter';
import React, { useCallback } from 'react';

import styles from './TeamRosterListHeader.module.scss';

interface ITeamRosterListHeaderProps {
  selected: keyof PlayerResponse | string;
  onChange?: React.MouseEventHandler<HTMLButtonElement>;
  ascending: boolean;
}
const columns: ColumnOption[] = [
  'jerseyNumber',
  'lastName',
  'position',
  'classRank',
  'age',
  'rating',
  'nilValue',
  'athleteVerified',
];
const headerListSelection = getColumnHeaderList(columns);

export const TeamRosterListHeader = ({
  selected,
  onChange,
  ascending,
}: ITeamRosterListHeaderProps) => {
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      onChange?.(e);
    },
    [onChange],
  );

  return (
    <>
      <div className={styles.mobileSort}>
        <SortFilter
          ascending={ascending}
          handleSort={handleClick}
          key={`${selected}-${ascending}`}
          selected={selected}
          sortList={headerListSelection}
        />
      </div>

      <header className={styles.wrapper}>
        <div className={styles.block}>
          {headerListSelection.map((item) => {
            const isSelected = item.name === selected;

            return (
              <div
                className={styles.item}
                data-name={item.displayName}
                id={item.ariaLabel}
                key={item.key}
                role="columnheader"
                title={item.displayName}
              >
                <button
                  className={styles.btnHeader}
                  data-active={isSelected}
                  data-ascending={item.flipDirection ? !ascending : ascending}
                  data-flip={item.flipDirection}
                  data-sorttype={item.name}
                  onClick={handleClick}
                >
                  {item.displayName}
                  {isSelected && <ArrowDownward />}
                </button>
              </div>
            );
          })}
        </div>
      </header>
    </>
  );
};
